import { Box3, Vector3, type Object3D } from "three"

export default function getComputedBoundingBoxSizeVector3(group : Object3D, size?: Vector3): Vector3 {
  // Create a bounding box
  const box = new Box3().setFromObject(group)
  size ||= new Vector3()
  box.getSize(size)
  return size
}